class FlowSettingResultModel {
    id: number;
    title?: string;
    flowId?: number;
    flowTitle?: string;
    flowSettingTitle?: string;
    flowSettingId: number;
    smsDefaultMsgId?: number|null;
    smsDefaultMsgTitle?: string;
    radFlowResultId?: number;
    isActive?: boolean;
    attachRequired?: boolean;
    codeRequired?: boolean;

    constructor(
        id: number,
        title: string,
        flowId: number,
        flowTitle: string,
        flowSettingTitle: string,
        flowSettingId: number,
        smsDefaultMsgId: number,
        smsDefaultMsgTitle: string,
        isActive: boolean,
        radFlowResultId: number,
        attachRequired: boolean,
        codeRequired: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.flowId = flowId;
        this.flowTitle = flowTitle;
        this.flowSettingTitle = flowSettingTitle;
        this.flowSettingId = flowSettingId;
        this.smsDefaultMsgId = smsDefaultMsgId;
        this.smsDefaultMsgTitle = smsDefaultMsgTitle;
        this.isActive = isActive;
        this.radFlowResultId = radFlowResultId;
        this.attachRequired = attachRequired;
        this.codeRequired = codeRequired;
    }

    public static fromJson(json: any): FlowSettingResultModel {
        return new FlowSettingResultModel(
            json["id"],
            json["title"],
            json["flowId"],
            json["flowTitle"],
            json["flowSettingTitle"],
            json["flowSettingId"],
            json["smsDefaultMsgId"],
            json["smsDefaultMsgTitle"],
            json["isActive"],
            json["radFlowResultId"],
            json["attachRequired"],
            json["codeRequired"],
        );
    }
}


export interface FlowSettingResultGetPayloadFilterModel {
    id?: number;
    title?: string;
    flowId?: number;
    flowSettingId?: number;
    radFlowResultId?: number;
    attachRequired?: number;
    codeRequired?: number;
    isActive?: number;
}

export interface FlowSettingResultGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: FlowSettingResultGetPayloadFilterModel;
}


export class FlowSettingResultPayloadModel {
    id: number;
    title?: string;
    flowId?: number;
    flowTitle?: string;
    flowSettingTitle?: string;
    flowSettingId: number;
    smsDefaultMsgId?: number|null;
    smsDefaultMsgTitle?: string;
    radFlowResultId?: number;
    isActive?: boolean;
    attachRequired?: boolean;
    codeRequired?: boolean;

    constructor(
        id: number,
        title: string,
        flowId: number,
        flowTitle: string,
        flowSettingTitle: string,
        flowSettingId: number,
        smsDefaultMsgId: number,
        smsDefaultMsgTitle: string,
        isActive: boolean,
        radFlowResultId: number,
        attachRequired: boolean,
        codeRequired: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.flowId = flowId;
        this.flowTitle = flowTitle;
        this.flowSettingTitle = flowSettingTitle;
        this.flowSettingId = flowSettingId;
        this.smsDefaultMsgId = smsDefaultMsgId;
        this.smsDefaultMsgTitle = smsDefaultMsgTitle;
        this.isActive = isActive;
        this.radFlowResultId = radFlowResultId;
        this.attachRequired = attachRequired;
        this.codeRequired = codeRequired;
    }
}
export default FlowSettingResultModel;
